module.exports = __webpack_public_path__ + "static/media/icon-no-announcements.7b4324ec.svg";